import { render, staticRenderFns } from "./ChallengeTermsConditions.vue?vue&type=template&id=adba4396&scoped=true"
import script from "./ChallengeTermsConditions.vue?vue&type=script&lang=js"
export * from "./ChallengeTermsConditions.vue?vue&type=script&lang=js"
import style0 from "./ChallengeTermsConditions.vue?vue&type=style&index=0&id=adba4396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adba4396",
  null
  
)

export default component.exports